.group {
	display: flex;
	flex-direction: column;
	gap: var(--lp-spacing-200);
}

.list {
	display: flex;
	flex-wrap: wrap;
	gap: var(--lp-spacing-200);
}

.tag {
	composes: selectable from './base.module.css';
	display: flex;
	gap: var(--lp-spacing-200);
	align-items: center;
	padding: var(--lp-spacing-100) var(--lp-spacing-200);
	border-radius: var(--lp-border-radius-medium);
	outline: none;

	&[data-focus-visible] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}

	&[data-disabled] {
		border-color: var(--lp-color-border-interactive-disabled);
		color: var(--lp-color-text-interactive-disabled);
	}

	&[data-selection-mode='multiple'] {
		background-color: var(--lp-color-bg-interactive-secondary-base);
		border: 1px solid var(--lp-color-border-interactive-secondary-base);
	}

	&[data-selected] {
		background-color: var(--lp-color-bg-interactive-selected);
		border-color: var(--lp-color-border-interactive-selected);
		color: var(--lp-color-text-interactive-selected);
	}

	&[data-allows-removing] {
		padding-right: 0;
	}
}

.small {
	font: var(--lp-text-label-2-medium);
	height: var(--lp-size-20);

	& [slot='remove'] {
		height: var(--lp-size-20);
		width: var(--lp-size-20);
		background-color: transparent;

		&[data-hovered] {
			background-color: transparent;
		}
	}
}

.medium {
	font: var(--lp-text-label-1-medium);
	height: var(--lp-size-24);
}

.default {
	color: var(--lp-color-text-ui-secondary);
	background-color: var(--lp-color-bg-ui-tertiary);
}

.success {
	color: var(--lp-color-text-feedback-success);
	background-color: var(--lp-color-bg-feedback-success);
}

.error {
	color: var(--lp-color-text-feedback-error);
	background-color: var(--lp-color-bg-feedback-error);
}

.warning {
	color: var(--lp-color-text-feedback-warning);
	background-color: var(--lp-color-bg-feedback-warning);
}

.beta {
	color: var(--lp-color-text-product-beta);
	background-color: var(--lp-color-bg-product-beta);
}

.federal {
	color: var(--lp-color-text-product-federal);
	background-color: var(--lp-color-bg-product-federal);
}

.new {
	color: var(--lp-color-text-feedback-success);
	background-color: var(--lp-color-bg-feedback-success);
}

.info {
	color: var(--lp-color-text-feedback-info);
	background-color: var(--lp-color-bg-feedback-info);
}
